export default "__VITE_ASSET__CJyFlNvI__"